function  conso(val) {

      const year = val.getFullYear();
      let month = val.getMonth() + 1;
      let day = val.getDate();
      let hour = val.getHours();
      let minute = val.getMinutes();
      if (month >= 1 && month <= 9) {
        month = `0${month}`;
      }
      if (day >= 1 && day <= 9) {
        day = `0${day}`;
      }
      if (hour >= 0 && hour <= 9) {
        hour = `0${hour}`;
      }
      if (minute >= 0 && minute <= 9) {
        minute = `0${minute}`;
      }
      sessionStorage.setItem('timeValue',`${year}-${month}-01`)
      sessionStorage.setItem('show2',false)
    }

function  dax(val,x) {
      const year = val.getFullYear();
      let month = val.getMonth() + 1;
      let day = val.getDate();
      let hour = val.getHours();
      let minute = val.getMinutes();
      if (month >= 1 && month <= 9) {
        month = `0${month}`;
      }
      if (day >= 1 && day <= 9) {
        day = `0${day}`;
      }
      if (hour >= 0 && hour <= 9) {
        hour = `0${hour}`;
      }
      if (minute >= 0 && minute <= 9) {
        minute = `0${minute}`;
      }
      if(x===1){
        sessionStorage.setItem('pact_date',`${year}-${month}-${day}`)
      }else {
        sessionStorage.setItem('end_date',`${year}-${month}-${day}`)
      }
      sessionStorage.setItem('show2',false)
    }




export{
    conso,
    dax
}



// WEBPACK FOOTER //
// ./src/utils/date.js